import { render, staticRenderFns } from "./OrderDetailProductTable.vue?vue&type=template&id=77d9fa0d&scoped=true&"
import script from "./OrderDetailProductTable.vue?vue&type=script&lang=js&"
export * from "./OrderDetailProductTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailProductTable.vue?vue&type=style&index=0&id=77d9fa0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d9fa0d",
  null
  
)

export default component.exports